import Isotope from 'isotope-layout';
import {currentLayout} from 'src/utils/base';
class CatCards {
  constructor() {
    this.testFlag = Signalman.featureFlag('subcat_redesign_v2');
    enquire.register(StyleBitz.Layouts.sm, () => this.enquireInit('sm'));
    enquire.register(StyleBitz.Layouts.md, () => this.enquireInit('md'));
    enquire.register(StyleBitz.Layouts.lg, () => this.enquireInit('lg'));
    enquire.register(StyleBitz.Layouts.xl, () => this.enquireInit('xl'));
  }

  reArrange() {
    const size = currentLayout();
    return this.enquireInit(size);
  }

  tileSize() {
    const tile = $('.pc-CatCard:eq(1)').get(0);
    if (this.testFlag) {
      return {width: 268, height: 160};
    } else if (tile) {
      const tileBoundingRect = tile.getBoundingClientRect();
      const width = tileBoundingRect.width;
      const height = tileBoundingRect.height;
      return {width, height};
    }
    return {width: 0, height: 0};
  }

  tileArea() {
    const ts = this.tileSize();
    return ts.width * ts.height;
  }

  // Private

  enquireInit(size) {
    if (!this.enquireInitable()) {
      return;
    }
    this.expertRevert();
    this.hatLayout(size);
    this.isoInit();
    return this.expertLayout(size);
  }

  enquireInitable() {
    return $('.pc-Categories, .pc-Subcategories').length;
  }

  isoInit() {
    this.isoDestroy();
    if (!this.isIsotopeInitable()) {
      return;
    }
    return (this.isotope = new Isotope(this.isoEl(), this.isoOptions()));
  }

  isoDestroy() {
    if (this.isotope != null) {
      this.isotope.unbindResize();
    }
    return delete this.isotope;
  }

  isIsotopeInitable() {
    return $('.pc-Categories .pc-CatCards').length;
  }

  isoEl() {
    return $('.pc-CatCards').get(0);
  }

  isoOptions() {
    return {
      itemSelector: '.pc-CatCard',
      percentPosition: true,
      transitionDuration: 0,
      masonry: {
        columnWidth: $('.pc-CatCard').get(1)
      },
      getSortData: {
        sm: (el) => this.isoSortBy('sm', el),
        md: (el) => this.isoSortBy('md', el),
        lg: (el) => this.isoSortBy('lg', el),
        xl: (el) => this.isoSortBy('xl', el)
      },
      sortBy: currentLayout()
    };
  }

  isoSortBy(size, el) {
    return parseFloat($(el).data(size));
  }

  expertCard() {
    return $(
      '.pc-Categories .pc-ExpertsCard, .pc-Subcategories .pc-ExpertsCard'
    );
  }

  expertRevert() {
    const card = this.expertCard();
    if (!card.length) {
      return;
    }
    const tileSize = this.tileSize();
    card.removeClass(this.expertModifiers());
    card.css({width: tileSize.width, height: tileSize.height});
    card.parent().css({width: tileSize.width, height: tileSize.height});
    const cardImg = card.find('.pc-ExpertsCard-image');
    cardImg.hide();
    return card.css({visibility: 'hidden'});
  }

  expertLayout(size) {
    const card = this.expertCard();
    if (!card.length) {
      return;
    }

    const expertCardDimensions = this.expertCardDimensions();
    const expertCardWidth = expertCardDimensions.width;
    const expertCardHeight = expertCardDimensions.height;
    const testSize = this.testFlag && (size === 'sm' ? 'sm' : 'lg');
    const cardSize = testSize || this.expertSize(size, expertCardWidth);

    card.removeClass(this.expertModifiers());
    card.addClass(this.expertModifiers(cardSize));
    card.css({width: expertCardWidth, height: expertCardHeight});
    card
      .parent()
      .css({width: expertCardWidth, height: expertCardHeight, display: 'block'});
    // account for additional height when Experts card will be
    // taking up the entire row
    if (this.testFlag) {
      card.css({width: '100%'});
      card.parent().css({width: '100%'});
    }
    if (expertCardDimensions.isFullWidth) {
      const $categoriesWrapperDiv = $('.pc-Categories .pc-CatCards');
      $categoriesWrapperDiv.css({
        height: $categoriesWrapperDiv.height() + expertCardHeight
      });
    }
    const cardImg = card.find('.pc-ExpertsCard-image');
    if (['sm', 'sm250'].includes(cardSize)) {
      cardImg.hide();
    } else {
      cardImg.show();
    }
    return card.css({visibility: 'visible'});
  }

  // Calculate the maximum number of tiles Experts card can take.
  // This method assumes the last cat card is always 1x1 card.
  expertAvailableTiles() {
    const lastCard = this.lastCard();
    const maxSingleTilesPerRow = this.maxSingleTilesPerRow();
    if (lastCard) {
      const lastCardPosition = Math.ceil(
        // offsetLeft & offsetWidth are rounded to nearest integer.
        // +2 accounts for this case.
        (lastCard.offsetLeft + 2) / lastCard.offsetWidth
      );

      return maxSingleTilesPerRow - lastCardPosition;
    }
    return 0;
  }

  expertCardDimensions() {
    const tileSize = this.tileSize();
    const lastCard = this.lastCard();
    const maxSingleTilesPerRow = this.maxSingleTilesPerRow();
    const availableTiles = this.expertAvailableTiles();

    let isFullWidth = false;
    let newWidth;

    if (availableTiles <= 0) {
      newWidth = tileSize.width * maxSingleTilesPerRow;
      if (this.testFlag && newWidth == 0) {
        newWidth = this.expertCard().parent().parent().width();
      }
      isFullWidth = true;
    } else {
      newWidth = tileSize.width * availableTiles;
      const totalWidth = newWidth + lastCard.offsetLeft;

      if (Math.ceil(totalWidth) >= $(lastCard).parent()[0].offsetWidth) {
        newWidth = newWidth - tileSize.width;
      }
    }

    return {
      // account for 1 px border around the card
      width: newWidth - 2,
      height: tileSize.height - 2,
      isFullWidth: isFullWidth
    }
  }

  expertSize(size, width) {
    if (size === 'sm') {
      if (width <= 350) {
        return 'sm';
      }
      return 'sm250';
    } else {
      if (width <= 350) {
        return 'sm';
      }
      if (width < 600) {
        return 'sm250';
      }
      if (width < 900) {
        return 'md';
      }
      if (width < 1250) {
        return 'lg';
      }
      return 'xl';
    }
  }

  expertModifiers(size) {
    const classes = [
      'pc-ExpertsCard--sm',
      'pc-ExpertsCard--sm250',
      'pc-ExpertsCard--md',
      'pc-ExpertsCard--lg',
      'pc-ExpertsCard--xl'
    ];
    if (size == null) {
      return classes.join(' ');
    }
    const slice = (() => {
      switch (size) {
        case 'sm':
          return 1;
        case 'sm250':
          return 2;
        case 'md':
          return 3;
        case 'lg':
          return 4;
        case 'xl':
          return 5;
      }
    })();
    return classes.slice(0, slice).join(' ');
  }

  maxSingleTilesPerRow() {
    if ($('.pc-CatCards').length) {
      const lastCardRect = this.lastCard().getBoundingClientRect();
      const catCardsRect = $('.pc-CatCards')[0].getBoundingClientRect();
      return Math.floor(
        catCardsRect.width / lastCardRect.width
      );
    }
    return 0;
  }

  lastCard() {
    return $('.pc-CatCard').not('.pc-CatCard--experts').last()[0];
  }

  hatCard() {
    return $('.pc-CatCard').eq(7);
  }

  hatLayout(size) {
    if ($('.pc-Categories-wrapper').length > 0) {
      const hatCatId = 1
      if (size === 'sm' && this.hatCard().data().catParentId === hatCatId) {
          return this.hatCard().removeClass('pc-CatCard--md');
      }
    }
  }
}

jQuery(() => (ProductCatalog.CatCards = new CatCards()));
